import React from "react";
import logo from "../assets/img/logo_pena.png";
import { useRef, useState, useEffect } from "react";
import { useSelector } from "react-redux";

import { selectUser } from "../reducers/userSlice";
import { LogoutLink } from "../auth/LogoutLink";
import { NavLink } from "react-router-dom";

const Header = ({ setmenuMobileState }) => {
  const [menuAbierto, setmenuAbierto] = useState(false);
  const [menuMobileAbierto, setmenuMobileAbierto] = useState(false);

  const [nombreUsuario, setnombreUsuario] = useState(null);
  const [perfilCompleto, setperfilCompleto] = useState(0);
  const [emailUsuario, setemailUsuario] = useState("Cargando datos");
  const menuRef = useRef();
  const sideRef = useRef();
  const user = useSelector(selectUser);

  const [sidebar, setsidebar] = useState(false);

  const handleSetSidebar = () => {
    if (sidebar) {
      setsidebar(false);
    } else {
      setsidebar(true);
    }
  };

  useEffect(() => {
    document.addEventListener("click", handleOutsideClick, true);
    if (user != null) {
      setperfilCompleto(user.user.perfil_completo);
      setnombreUsuario(`${user.user.name} ${user.user.lastname} ${user.user.second_lastname}`);
      setemailUsuario(user.user.email);

    }
  }, [user]);

  const Avatar = () => {

    if (nombreUsuario!=null) {
      return <div className="circuloAvatar">{nombreUsuario.toString()[0]}</div>;
    }

  };

  const handleMenu = () => {
    if (!menuAbierto) {
      setmenuAbierto(true);
    } else {
      setmenuAbierto(false);
    }
  };

  const handleMenuMobile = () => {
    if (!menuMobileAbierto) {
      //setmenuMobileAbierto(true);
      setmenuMobileState(true);
    } else {
      //setmenuMobileAbierto(false);
      setmenuMobileState(false);
    }
  };

  const handleOutsideClick = (e) => {
    try {
      if (!menuRef.current.contains(e.target)) {
        setmenuAbierto(false);
      }
      if (!sideRef.current.contains(e.target)) {
        setsidebar(false);
      }
    } catch (error) {}
  };

  console.log(user);

  return (
    <div id="kt_app_header" className="app-header">
      <div
        className="app-wrapper"
        id="kt_app_wrapper"
      >
        <div
          ref={sideRef}
          id="kt_app_sidebar"
          className={`app-sidebar drawer drawer-start ${
            sidebar ? `drawer-on` : `drawer-off`
          }`}
          data-kt-drawer="true"
          data-kt-drawer-name="app-sidebar"
          data-kt-drawer-activate="{default: true, lg: false}"
          data-kt-drawer-overlay="true"
          data-kt-drawer-width="auto"
          data-kt-drawer-direction="start"
          data-kt-drawer-toggle="#kt_app_sidebar_mobile_toggle"
        >
          <div className="container" style={{ marginTop: 0 }}>
            <div className="row pt-4">
              <div className="col-6">
                <h4 className="text-white">GSV</h4>
              </div>
              <div className="col-6 pr-4" style={{ textAlign: "right" }}>
                <span
                  className="svg-icon svg-icon-primary svg-icon-2x pointer mr-3"
                  onClick={handleSetSidebar}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24px"
                    height="24px"
                    viewBox="0 0 24 24"
                    version="1.1"
                  >
                    <g
                      stroke="none"
                      strokeWidth="1"
                      fill="none"
                      fillRule="evenodd"
                    >
                      <polygon points="0 0 24 0 24 24 0 24" />
                      <rect
                        fill="#ffffff"
                        opacity="0.3"
                        transform="translate(15.000000, 12.000000) scale(-1, 1) rotate(-90.000000) translate(-15.000000, -12.000000) "
                        x="14"
                        y="7"
                        width="2"
                        height="10"
                        rx="1"
                      />
                      <path
                        d="M3.7071045,15.7071045 C3.3165802,16.0976288 2.68341522,16.0976288 2.29289093,15.7071045 C1.90236664,15.3165802 1.90236664,14.6834152 2.29289093,14.2928909 L8.29289093,8.29289093 C8.67146987,7.914312 9.28105631,7.90106637 9.67572234,8.26284357 L15.6757223,13.7628436 C16.0828413,14.136036 16.1103443,14.7686034 15.7371519,15.1757223 C15.3639594,15.5828413 14.7313921,15.6103443 14.3242731,15.2371519 L9.03007346,10.3841355 L3.7071045,15.7071045 Z"
                        fill="#ffffff"
                        fillRule="nonzero"
                        transform="translate(9.000001, 11.999997) scale(-1, -1) rotate(90.000000) translate(-9.000001, -11.999997) "
                      />
                    </g>
                  </svg>
                </span>
              </div>
            </div>


              <div className="row mr-3">
                <div className="col-md-12 pt-4">
                    <h3 className="menu-link">
                      <NavLink to={"/home"} onClick={handleSetSidebar} className="menu-title text-white">
                        <i className="fas fa-home mr-2"></i>
                        Inicio
                      </NavLink>
                    </h3>
                </div>

                {perfilCompleto ==1 ?
                  <div className="col-md-12 pt-4">
                    <h3 className="menu-link">
                      <NavLink to={`/CrearSolicitud`} onClick={handleSetSidebar} className="menu-title text-white">
                        <i className="fas fa-plus mr-2 fa-2x"></i>
                        Nueva Solicitud
                      </NavLink>
                    </h3>
                </div>
                : <></>
                }
              </div>




          </div>
        </div>
      </div>

      {/*begin::Header container*/}
      <div
        className="app-container container d-flex align-items-stretch justify-content-between"
        id="kt_app_header_container"
      >
        {/*begin::Header logo*/}
        <div className="app-header-logo d-flex align-items-center ps-lg-2 me-lg-10">
          {/*begin::Mobile toggle*/}
          <div
            className="btn btn-icon btn-color-gray-500 btn-active-color-primary w-35px h-35px ms-n2 me-2 d-flex d-lg-none"
            id="kt_app_sidebar_mobile_toggle"
          >
            <i
              onClick={handleSetSidebar}
              className="ki-outline ki-abstract-14 fs-1"
            />
          </div>
          {/*end::Mobile toggle*/}
          {/*begin::Logo image*/}
          <NavLink to={"/home"}>
            <img alt="Logo" src={logo} className="h-30px" />
          </NavLink>
          {/*end::Logo image*/}
        </div>
        {/*end::Header logo*/}
        {/*begin::Header wrapper*/}
        <div className="d-flex align-items-stretch justify-content-end flex-lg-grow-1">
          {/*begin::Menu wrapper*/}
          <div
            className="d-flex align-items-stretch"
            id="kt_app_header_menu_wrapper"
          >
            {/*begin::Menu holder*/}
            <div className="app-header-menu app-header-mobile-drawer align-items-stretch">
              {/*begin::Menu*/}

              <div
                className="menu menu-rounded menu-column menu-lg-row menu-active-bg menu-title-gray-600 menu-state-dark menu-arrow-gray-400 fw-semibold fw-semibold fs-6 align-items-stretch my-5 my-lg-0 px-2 px-lg-0"
                id="#kt_app_header_menu"
                data-kt-menu="true"
              >
                <div className="menu-item here show menu-here-bg menu-lg-down-accordion me-0 me-lg-2">
                  <span className="menu-link">
                    <NavLink to={"/home"} className="menu-title">
                      <i className="fas fa-home mr-2"></i>
                      Inicio
                    </NavLink>
                  </span>
                </div>

                {perfilCompleto==1 ?
                <div className="menu-item here show menu-here-bg menu-lg-down-accordion me-0 me-lg-2">
                  <span className="menu-link">
                    <NavLink to={`/CrearSolicitud`} className="menu-title btn btn-primary text-white">
                      <i className="fas fa-plus mr-2" style={{fontSize:20,fontWeight:900}}></i>
                      Nueva Solicitud
                    </NavLink>
                  </span>
                </div> : <></> }
              </div>


            </div>
            {/*end::Menu holder*/}
          </div>
          {/*end::Menu wrapper*/}
          {/*begin::Navbar*/}
          <div className="app-navbar flex-shrink-0">
            <div className="d-flex align-items-stretch flex-shrink-0">
              <div
                className="d-flex align-items-center ms-1 ms-lg-3"
                id="kt_header_user_menu_toggle"
              >
                {!menuAbierto ? (
                  <div
                    onClick={handleMenu}
                    className="cursor-pointer symbol symbol-30px symbol-md-40px menu-dropdown"
                    data-kt-menu-trigger="click"
                    data-kt-menu-attach="parent"
                    data-kt-menu-placement="bottom-end"
                  >
                    { nombreUsuario!=null ? <Avatar></Avatar> : <></>}
                  </div>
                ) : (
                  <></>
                )}
                <div
                  ref={menuRef}
                  style={{ marginTop: 110, backgroundColor: "#ffffff" }}
                  className={
                    menuAbierto
                      ? "menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-800 menu-state-bg menu-state-primary fw-bold py-4 fs-6 w-275px show"
                      : "menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-800 menu-state-bg menu-state-primary fw-bold py-4 fs-6 w-275px"
                  }
                  data-kt-menu="true"
                >
                  <div className="menu-item px-3">
                    <div className="menu-content d-flex align-items-center px-3">
                      <div className="me-5">
                        <Avatar nombreUsuario={nombreUsuario}></Avatar>
                      </div>
                      <div className="d-flex flex-column">
                        <div className="fw-bolder d-flex align-items-center fs-5">
                          {nombreUsuario}
                        </div>
                        <a
                          href="#/"
                          className="fw-bold text-muted text-hover-primary fs-7"
                        >
                          {emailUsuario}
                        </a>
                      </div>
                    </div>
                  </div>
                  <div className="separator my-2"></div>

                  {
                  perfilCompleto==1 ?
                  <div className="menu-item px-5">
                    <NavLink to={`/EditarPerfil`} className="menu-link px-5">
                      Mi perfil
                    </NavLink>
                  </div> : <></>}

                  <div className="separator my-2"></div>

                  <div className="menu-item px-5">
                    <LogoutLink className="menu-link px-5"></LogoutLink>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/*end::Navbar*/}
        </div>
        {/*end::Header wrapper*/}
      </div>
      {/*end::Header container*/}
    </div>
  );
};

export default Header;
